import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';

import { closeCreateReservationModal } from '../../../actions/siteadmin/modalActions';
import messages from '../../../locale/messages';
import CreateReservationForm from './CreateReservationForm';

import s from './CreateReservationModal.css';

class CreateReservationModal extends Component {
  render() {
    const { closeCreateReservationModal, createReservationModal } = this.props;

    return (
      <div>
        <Modal
          show={createReservationModal}
          onHide={closeCreateReservationModal}
          className={'adminModal'}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <FormattedMessage {...messages.createComplimentaryBooking} />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <CreateReservationForm />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapState = (state) => ({
  createReservationModal: state.adminModalStatus.createReservationModal,
});

const mapDispatch = {
  closeCreateReservationModal,
};

export default injectIntl(
  withStyles(s)(connect(mapState, mapDispatch)(CreateReservationModal))
);
